module.exports = __webpack_public_path__ + "static/media/Gold-Host-NA-Partner.fb702f6d.png";